import {authService} from './../services/authService'
const authServiceprovider = authService;


export const loading = (isLoading) =>  {
    return({
        type:"APP_LOADING",
        isLoading:isLoading
    })
};

export const loginUser = (userInfo) =>  {
    const {given_name:fullName,website:subDomain,address} = userInfo;
    return({
        type:"USER_LOGIN",
        userInfo:{
            fullName,
            subDomain,
            address
        }
 })
};

export const startLoginUser = ({username,password}) =>{
    return async dispatch =>{
        try{
            const res = await authServiceprovider.login(username, password);
            dispatch(loginUser(res));
        }catch(error){
            throw(error);
        } 
    }
};
export const logoutUser = () =>  {
    return({
        type:"USER_LOGOUT"
    })
};
export const startLogoutUser =  () =>  {
    return async dispatch =>{
        try{
            await authServiceprovider.logout()
            dispatch(logoutUser());
        }catch(error){
            throw(error);
        }
        
    }
};